<template>
    <div class="layout_ policy_layout_">
        <navbar />
        <div class="content_ w1000_">
            <div class="breadcrum_">首页 > 发票管理</div>
            <div class="tabs_ bold_">
                <div @click="goUserInfo">个人信息管理</div>
                <div @click="goPolicy">服务中心</div>
                <div class="active_">发票管理</div>
            </div>
            <div class="labels_wrap_">
                <router-link exact-active-class="active_" class="label_" :to="{name: 'queryInvoice'}">发票查询</router-link>
            </div>
            <router-view></router-view> 
        </div>
        <footbar></footbar>
    </div>
</template>
<style lang="scss" scoped>
.layout_ {
    .labels_wrap_ {
        font-size: 13px;
        white-space: nowrap;
        margin: 26px 0 30px;
        .label_ {
            display: inline-block;
            margin-right: 33px;
            color: #666666;
            text-decoration: none;
            &.router-link-exact-active {

            }

            &.active_ {
                color: #333;
                &::after {
                    display: block;
                    content: '';
                    width: 25px;
                    height: 2px;
                    margin: 0 auto;
                    background: #FF4C1C;
                    margin-top: 8px;
                }
            }
        }
    }
    .breadcrum_ {
        font-size: 12px;
        color: #666666;
        margin: 34px 0 24px;
    }
    .tabs_ {
        line-height: 49px;
        border-bottom: 3px solid #FF4C1C;

        & > div {
            display: inline-block;
            width:215px;
            height:50px;
            text-align: center;
            border-radius:3px 3px 0px 0px;
            font-size: 17px;
            margin-bottom: -1px;
            cursor:pointer;
            &.active_ {
                color: #fff;
                background:rgba(255,76,28,1);
            }
        }
    }
}
</style>
<script>
import navbar from '../components/navbar'
import footbar from '../components/footbar'
import moment from "moment";
import api from '@/utils/api'
export default {
    data () {
        return {
            myArray:[]
        }
    },
    components: {
        navbar,footbar
    },
    mounted() {
        this.getSetting()
    },
    methods: {
       getSetting(){

       },
       goUserInfo(){
           this.$router.push({
                name: "addCard"
            });
       },
       goPolicy(){
           this.$router.push({
                name: "policy"
            });
       }
    }
}
</script>